<template>
	<div class="adsearchbg search">
		<!-- :class="'search ' + (isShowad ? 'adsearchbg' : 'fastsearchbg')" -->
		<div class="tabbox">
			<div class="searchbox">
				<!-- <div class="titlegroup">
					<div :class="'title pointer ' + class1" @click="handleChangetab(1)">
						<el-badge v-if="specialEquipmentCount !== null && specialEquipmentCount !== undefined && specialEquipmentCount !== ''" :value="specialEquipmentCount" class="item" type="warning">
							<span>特种设备法规标准库</span>
						</el-badge>
						<span v-else>特种设备法规标准库</span>
					</div>

					<div :class="'title pointer ' + class2" @click="handleChangetab(2)">
						<el-badge v-if="allCount !== null && allCount !== undefined && allCount !== '' && allCount !== 0" :value="allCount" class="item" type="warning">
							<span>全国标准库</span>
						</el-badge>
						<span v-else>全国标准库</span>
					</div>
				</div> -->
				<div v-show="isShowfast" class="fastSearch">
					<!-- <fastSearch></fastSearch> -->
					<tzsbSearch ref="tzsbSearchRef" @showProduct="$emit('showProduct', $event)" @queryType="$emit('queryType', $event)"></tzsbSearch>
				</div>
				<div v-show="isShowad" class="advancedSearch">
					<!-- <adSearch></adSearch> -->
					<qgSearch ref="qgSearchRef"></qgSearch>
				</div>
				<!-- <div v-show="isShowai" class="aiSearch">
					<aiSearch></aiSearch>
				</div> -->
			</div>
		</div>
	</div>
</template>

<script>
// 私有模块
import fastSearch from './components/fastsearch.vue';
import adSearch from './components/adsearch.vue';
import aiSearch from './components/aisearch.vue';
import tzsbSearch from './components/tzsbSearch.vue';
import qgSearch from './components/qgSearch.vue';
import { getSearchStandardCount, getSearchSpecialEquipmentCount } from '@/api/standards/search.js';
import { mapGetters } from 'vuex';
import Y from '@/utils/Y';

export default {
	data() {
		return {
			isShowfast: true,
			isShowad: false,
			isShowai: false,
			class1: 'titleon',
			class2: 'titleoff',
			class3: 'titleoff',

			searchParam: {
				itype: 1
			},

			allCount: 0,
			specialEquipmentCount: 0
		};
	},
	components: {
		fastSearch,
		adSearch,
		aiSearch,
		tzsbSearch,
		qgSearch
	},
	computed: {
		...mapGetters('User', ['uisLogin'])
	},
	methods: {
		async getSearchStandardCount() {
			let res = await getSearchStandardCount();
			if (res.code == 200) {
				this.allCount = res.data;
			}
		},
		async getSearchSpecialEquipmentCount() {
			let res = await getSearchSpecialEquipmentCount();
			if (res.code == 200) {
				this.specialEquipmentCount = res.data;
			}
		},

		handleChangetab(param) {
			if (param == 1) {
				this.isShowfast = true;
				this.isShowad = false;
				this.isShowai = false;
				this.class1 = 'titleon';
				this.class2 = 'titleoff';
				this.class3 = 'titleoff';
				this.searchParam.itype = 1;
			} else if (param == 2) {
				// 检查登录状态
				if (!this.uisLogin) {
					Y.msg.warning('请先登录后再访问全国标准库');
					return;
				}
				this.$router.push({
					path: '/StandardAdvanced'
				});
				return;
				this.isShowfast = false;
				this.isShowad = true;
				this.isShowai = false;
				this.class1 = 'titleoff';
				this.class2 = 'titleon';
				this.class3 = 'titleoff';
				this.searchParam.itype = 0;
			} else {
				this.isShowfast = false;
				this.isShowad = false;
				this.isShowai = true;
				this.class1 = 'titleoff';
				this.class2 = 'titleoff';
				this.class3 = 'titleon';
			}
			this.$emit('itypeCheck', this.searchParam.itype);
		},
		resetSearchParams() {
			this.$refs.tzsbSearchRef.resetSearchParams();
			this.$refs.qgSearchRef.resetSearchParams();
			// 触发父组件的重置事件
			// this.$emit('reset');
		},
		onSubmit() {}
	},
	// 加载完执行
	created() {
		// this.getSearchStandardCount();
		// this.getSearchSpecialEquipmentCount();
	},

	mounted() {
		// if (this.$route.query.stype == 'ad') {
		// 	this.handleChangetab(2);
		// } else if (this.$route.query.stype == 'ai') {
		// 	this.handleChangetab(3);
		// }
	}
};
</script>

<style lang="less" scoped>
.search {
	// background: url(@/assets/searchbanner/searchbg.jpg) no-repeat center center;
	// height: 235px;
	// background-size: cover;
	display: flex;
	justify-content: center;
	align-items: center;
	.tabbox {
		width: 100%;
		.searchbox {
			.titlegroup {
				display: flex;
				justify-content: start; /* 水平居中 */
				align-items: center; /* 垂直居中 */
				gap: 5px;
				.title {
					border-radius: 7px 7px 0 0;
					font-weight: 400;
					font-size: 16px;
					// width: 115px;
					height: 40px;
					line-height: 40px;
					text-align: center;
					// padding: 4px 26px;
					padding: 4px 42px;
				}
				.titleon {
					background-color: #ffffff;
					color: #1474e2;
					font-weight: 600;
				}
				.titleoff {
					background-color: #e9f3ff;
					color: #333333;
				}
			}
		}
	}

	// /deep/ .el-input {
	//   box-shadow: 0px 3px 7px 0px rgba(0,122,255,0.1);
	//   border-radius: 0px 7px 7px 7px;
	// }
}
.fastsearchbg {
	background: url(@/assets/images/searchbanner/searchbg.jpg) no-repeat center center;
	background-size: cover;
	height: 235px;
}
.adsearchbg {
	// background: url(@/assets/images/searchbanner/bg.png) no-repeat center center;
	// background-size: cover;
	// height: 496px;
	// padding: 30px 0;
	// min-height: 350px;
}
::v-deep .searchbtn {
	width: 120px;
	height: 37px;
	// line-height: 37px;
	background: linear-gradient(40deg, #2969f0, #2ba5fd);
	border-radius: 7px;
	font-weight: 400;
	font-size: 16px;
	color: #fefefe;
	// text-align: center;
	display: flex;
	justify-content: center;
	align-items: center;
}
::v-deep .searchbtn:hover {
	background: linear-gradient(40deg, #1b56d2, #2596e8);
}
::v-deep input[type='text'] {
	padding-left: 18px;
}
/* 仅移除输入框的聚焦边框 */
::v-deep input[type='text']:focus {
	outline: none;
	// border: 0;
}
::v-deep input::placeholder {
	color: #cccccc; /* 浅灰色，可自定义（如 #666、#ccc 等） */
	opacity: 1; /* 部分浏览器默认 opacity < 1，设置为 1 确保颜色纯正 */
	font-size: 14px;
}
</style>
